export default __webpack_public_path__ + "static/media/P945MANB3.e213548a.pdf";